import { Base } from './Base';
import anime from 'animejs';

const selectors = {
    labels: '.labels--mobile',
    label: '.label',
}

const classes = {
    ghost: 'ghost',
}

export class AnnouncementBar extends Base {
    constructor(behaviourName, element ) {
        super(behaviourName, element);
        
        const { labels } = this.refs;
        const labelsArray = labels.querySelectorAll(selectors.label);
        
        if(labelsArray.length > 1) {

            const elememtHeight = this.element.getBoundingClientRect().height;
            const labelClone = labelsArray[0].cloneNode(true);
            const keyframes = [
                {"translateY": 0, "duration":0}
            ];
            
            labelClone.classList.add(classes.ghost);
            labels.appendChild(labelClone);

            for(let i = 0; i<labelsArray.length; i++) {
                const keyframe = {
                    "translateY": `-${elememtHeight * (i + 1)}px`,
                    "duration": 1000, 
                    "delay": 1000
                }
                keyframes.push(keyframe);
            }

            anime({
                targets: labels,
                keyframes: keyframes, 
                easing: 'linear', 
                loop: true,
            });
        }
    }
}


